/* eslint-disable camelcase */
import qs from 'qs';
import { requestQueryStack } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getClientsDefaults = async (from, to) => {
  const options = getOptions();
  options.params = { filter: { createdAt: { since: from, until: to } } };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('client-default', options)).data;
};

const getEvents = async (type, from, to, events, goals, subtype, country) => {
  const options = getOptions();
  options.params = { type, from, to, events, goals };
  if (subtype) options.params.subtype = subtype;
  if (country) options.params.subtype = country;
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('daily-analytics-events', options)).data;
};

const getEventsSteps = async (from, to, country) => {
  const options = getOptions();
  options.params = { from, to, country };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('simulation/stepsV2', options)).data;
};

const getEventsCampaignPerformed = async (from, to, country) => {
  const options = getOptions();
  options.params = { from, to, country };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('simulation/campaign-performed', options)).data;
};

const getEventsCollectings = async (meta, search) => {
  const options = getOptions();
  options.params = { meta, search };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('collectings', options)).data;
};

const getEventsCollectingsInvestors = async () => {
  return (await requestQueryStack.get('collectings/investors')).data;
};

const getUserPresence = async (from, to, country, user_type, investorId) => {
  const options = getOptions();
  options.params = { from, to, country, user_type, investorId };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('user-presence', options)).data;
};

const getUserActions = async (from, to, country, user_type, timeInterval, investorId) => {
  const options = getOptions();
  options.params = { from, to, country, user_type, timeInterval, investorId };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('user-actions', options)).data;
};

const getEventsIndicators = async (from, to, country, monthDiff) => {
  const options = getOptions();
  options.params = { from, to, country, monthDiff };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('indicators/group', options)).data;
};

const getUserActionsInvestor = async (from, to, country, moduleName, timeInterval, investorId) => {
  const options = getOptions();
  options.params = { from, to, country, moduleName, timeInterval, investorId };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('user-actions/investors', options)).data;
};

export const getSimulationsCreated = async (from, to) => getEvents('creditu.simulation.2.event.simulation.created', from, to, false, false);
export const getTransactionProviderUpdated = async (from, to) => getEvents('creditu.transaction.1.event.provider.updated', from, to, true, false, 'cl/SERVIPAG_BUTTON');
export const getTransactionConfirmed = async (from, to) => getEvents('creditu.transaction.1.event.transaction.confirmed', from, to, true, true, 'CL/SERVIPAG_BUTTON');
export const getTransactionRejected = async (from, to) => getEvents('creditu.transaction.1.event.transaction.rejected', from, to, true, false, 'CL/SERVIPAG_BUTTON');
export const getBoletoRequested = async (from, to) => getEvents('creditu.boleto.1.event.boleto.requested', from, to, true, false, 'BR/ITG');
export const getBoletoRequestFailed = async (from, to) => getEvents('creditu.boleto.1.event.boleto.request-failed', from, to, true, false, 'BR/ITG');

// Indicators
export const getUFBCIndicatorsImported = async (from, to) => getEvents('creditu.indicator.1.event.indicator.imported', from, to, true, true, 'CL/CL-UF/BANCO-CENTRAL-DE-CHILE');
export const getUFCMFIndicatorsImported = async (from, to) => getEvents('creditu.indicator.1.event.indicator.imported', from, to, true, true, 'CL/CL-UF/CMF-CHILE');
export const getIPCAIBGEIndicatorsImported = async (from, to) => getEvents('creditu.indicator.1.event.indicator.imported', from, to, true, true, 'BR/BR-IPCA-DEBT/IBGE-BRASIL');
export const getUFBCIndicatorsImportFailed = async (from, to) => getEvents('creditu.indicator.1.event.indicator.import-failed', from, to, true, true, 'CL/CL-UF/BANCO-CENTRAL-DE-CHILE');
export const getUFCMFIndicatorsImportFailed = async (from, to) => getEvents('creditu.indicator.1.event.indicator.import-failed', from, to, true, true, 'CL/CL-UF/CMF-CHILE');
export const getIPCAIBGEIndicatorsImportFailed = async (from, to) => getEvents('creditu.indicator.1.event.indicator.import-failed', from, to, true, true, 'BR/BR-IPCA-DEBT/IBGE-BRASIL');

// http://localhost:3001/simulation/campaign-performed?from=2021-10-14&to=2021-10-14&country=CL
export const getSimulationSteps = async (from, to, country) => getEventsSteps(from, to, country);
export const getSimulationsCampaignPerformed = async (from, to, country) => getEventsCampaignPerformed(from, to, country);
export const getCollectings = async (meta, search) => getEventsCollectings(meta, search);
export const getCollectingsInvestors = async () => getEventsCollectingsInvestors();
export const getUserTrackPresence = async (from, to, country, user_type, investorId) => getUserPresence(from, to, country, user_type, investorId);
export const getUserTrackActions = async (from, to, country, user_type, timeInterval, investorId) => getUserActions(from, to, country, user_type, timeInterval, investorId);
export const getUserTrackActionsInvestor = async (from, to, country, moduleName, timeInterval, investorId) => getUserActionsInvestor(from, to, country, moduleName, timeInterval, investorId);
export const getIndicators = async (from, to, country, monthDiff) => getEventsIndicators(from, to, country, monthDiff);

export const getDailyMetrics = async (type, subtype, name, from, to) => {
  const options = getOptions();
  options.params = { type, subtype, name, from, to };
  options.paramsSerializer = params => {
    return qs.stringify(params);
  };
  return (await requestQueryStack.get('daily-analytics-events', options)).data;
};
